<form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>

  <div class="stepper-container">
    <div class="steps-header complete">
      <!-- If check mark is needed just add completed class in the div below ... -->
      <div class="step first" [class.active]="currentStep === 1">
        <div class="step-header" (keyup.enter)="setStep(1)" tabindex="0" (click)="setStep(1)">
          <div class="step-number">1</div>
          <div class="step-title">General</div>
        </div>
      </div>
      <div class="step" [class.active]="currentStep === 2">
        <div (keyup.enter)="setStep(2)" tabindex="0" class="step-header" (click)="setStep(2)">
          <div class="step-number">2</div>
          <div class="step-title">Routing Parameters (Optional)</div>
        </div>
      </div>
    </div>
    <div class="steps-body-wrap">
      <!-- General details -->
      <div class="step-body" [hidden]="currentStep !== 1">
        <div class="suppliers-wrap">
          <div class="supplier-detail">
            <h5 class="mb-15">General Information</h5>
            <div class="form-row">
              <div class="form-group">
                <label for="title" class="form-label required">Supplier Name </label>
                <input
                  [(ngModel)]="model.title"
                  formControlName="title"
                  type="text"
                  class="form-control"
                  id="title"
                  placeholder="Supplier A, B, etc"
                  required />
                <input-errors [control]="form.controls.title" [service]="validationService"></input-errors>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label for="route" class="form-label required">Route type </label>
                <select [(ngModel)]="model.routeType" formControlName="routeType" name="route" id="route" class="form-select">
                  <option *ngFor="let routeType of routeTypes" [value]="routeType.id">
                    {{ routeType.label }}
                  </option>
                </select>
                <input-errors [control]="form.controls.routeType" [service]="validationService"></input-errors>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group" *ngIf="model.routeType === 'Custom'">
                <label class="form-label required">Custom route type</label>
                <input type="text" class="form-control" formControlName="customRouteType" placeholder="Enter custom route type" required />
                <input-errors [control]="form.controls.customRouteType" [service]="validationService"></input-errors>
              </div>
            </div>
          </div>

          <hr class="text-neutral-n4" />

          <div class="attribute-detail">
            <div>
              <h5 class="my-10 text-neutral-n9">Add Attributes</h5>
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-between align-items-center mb-10">
                  <span class="label">Localisation</span>
                  <div class="btn-group" role="group">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="onAttributeSelected('NONE_LOCAL')"
                      [ngClass]="{ active: !attributeSelections['DOMESTIC'] && !attributeSelections['INTERNATIONAL'] }">
                      None
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="onAttributeSelected('DOMESTIC')"
                      [ngClass]="{ active: attributeSelections['DOMESTIC'] }">
                      <i class="icon-domestic text-accent-a6"></i> Domestic
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="onAttributeSelected('INTERNATIONAL')"
                      [ngClass]="{ active: attributeSelections['INTERNATIONAL'] }">
                      <i class="fas fa-globe text-accent-a5"></i> International
                    </button>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-10">
                  <span class="label">Type</span>
                  <div class="btn-group" role="group">
                    <button
                      type="button"
                      class="btn btn-secondary active"
                      (click)="onAttributeSelected('NONE_TYPE')"
                      [ngClass]="{ active: !attributeSelections['TRANSACTIONAL'] && !attributeSelections['PROMOTIONAL'] }">
                      None
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="onAttributeSelected('TRANSACTIONAL')"
                      [ngClass]="{ active: attributeSelections['TRANSACTIONAL'] }">
                      <i class="icon-security text-success-s2"></i> Transactional
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="onAttributeSelected('PROMOTIONAL')"
                      [ngClass]="{ active: attributeSelections['PROMOTIONAL'] }">
                      <i class="icon-promotional text-accent-a2"></i> Promotional
                    </button>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-20">
                  <span class="label">Sender ID</span>
                  <div class="btn-group" role="group">
                    <button
                      type="button"
                      class="btn btn-secondary active"
                      (click)="onAttributeSelected('NONE_SENDER')"
                      [ngClass]="{ active: !attributeSelections['SHORT_CODE'] && !attributeSelections['LONG_CODE'] }">
                      None
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="onAttributeSelected('SHORT_CODE')"
                      [ngClass]="{ active: attributeSelections['SHORT_CODE'] }">
                      <i class="icon-api text-primary"></i> Short-Code
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="onAttributeSelected('LONG_CODE')"
                      [ngClass]="{ active: attributeSelections['LONG_CODE'] }">
                      <i class="icon-long-code text-primary"></i> Long-Code
                    </button>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-10">
                  <span class="label">Other</span>
                  <div class="checkboxes-group">
                    <div
                      class="d-flex gap-10 align-items-center cp mb-10"
                      (keyup.enter)="onAttributeSelected('PRE_REGISTRATION')"
                      tabindex="0"
                      (click)="onAttributeSelected('PRE_REGISTRATION')">
                      <input type="checkbox" class="form-check-input" type="checkbox" [checked]="attributeSelections['PRE_REGISTRATION']" />
                      <div>
                        <span class="icon me-10 icon-pre-registration text-accent-a2"></span>
                        <span class="text">Pre-registration</span>
                      </div>
                    </div>
                    <div
                      (keyup.enter)="onAttributeSelected('TWO_WAY')"
                      tabindex="0"
                      class="d-flex gap-10 align-items-center cp mb-10"
                      (click)="onAttributeSelected('TWO_WAY')">
                      <input type="checkbox" class="form-check-input" type="checkbox" [checked]="attributeSelections['TWO_WAY']" />
                      <div>
                        <span class="icon me-10 icon-test-sender-id-replaced text-accent-a5"></span>
                        <span class="text">Two-way</span>
                      </div>
                    </div>
                    <div
                      (keyup.enter)="onAttributeSelected('P2P')"
                      tabindex="0"
                      class="d-flex gap-10 align-items-center cp mb-10"
                      (click)="onAttributeSelected('P2P')">
                      <input type="checkbox" class="form-check-input" type="checkbox" [checked]="attributeSelections['P2P']" />
                      <div>
                        <span class="icon me-10 icon-senders text-accent-a3"></span>
                        <span class="text">P2P</span>
                      </div>
                    </div>
                    <div
                      (keyup.enter)="onAttributeSelected('SMSC')"
                      tabindex="0"
                      class="d-flex gap-10 align-items-center cp mb-10"
                      (click)="onAttributeSelected('SMSC')">
                      <input type="checkbox" class="form-check-input" type="checkbox" [checked]="attributeSelections['SMSC']" />
                      <div>
                        <span class="icon me-10 icon-network text-accent-a7"></span>
                        <span class="text">SMSC DLR</span>
                      </div>
                    </div>
                    <div
                      (keyup.enter)="onAttributeSelected('SPAM')"
                      tabindex="0"
                      class="d-flex gap-10 align-items-center cp mb-10"
                      (click)="onAttributeSelected('SPAM')">
                      <input type="checkbox" class="form-check-input" type="checkbox" [checked]="attributeSelections['SPAM']" />
                      <div>
                        <span class="icon me-10 fas fa-comment-slash text-accent-a2"></span>
                        <span class="text">SPAM</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr class="text-neutral-n4" />

          <div class="supplier-detail">
            <h5 class="my-15 text-neutral-n9">Comment</h5>
            <div class="form-row">
              <div class="form-group">
                <textarea
                  [(ngModel)]="model.comment"
                  formControlName="comment"
                  id="comment"
                  cols="30"
                  rows="6"
                  placeholder="Comment"
                  class="form-control"></textarea>
                <input-errors [control]="form.controls.comment" [service]="validationService"></input-errors>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Routing parameters, optional -->
      <div class="step-body" [hidden]="currentStep !== 2">
        <div class="supply-parameter">
          <h3 class="mb-15">Routing Parameters (Optional)</h3>
          <div class="alert alert-primary">
            Routing parameters are optional and enable your system to distinguish between various suppliers when sending tests through the same SMPP
            session.
          </div>
          <div class="d-flex flex-column gap-20">
            <div>
              <div class="form-group">
                <label for="service" class="form-label">Service Type</label>
                <span
                  class="icon icon-help-1 text-neutral-n6 ms-0_5"
                  tooltip="<b>Service Type</b> is an optional parameter used for routing. <br>
                                Enter the unique value of the Service Type that matches the service type you have set up on your own server for this supplier.">
                </span>
                <input
                  [(ngModel)]="model.serviceType"
                  formControlName="serviceType"
                  type="text"
                  class="form-control"
                  id="service"
                  placeholder="576" />
                <input-errors [control]="form.controls.serviceType" [service]="validationService"></input-errors>
              </div>
            </div>
            <hr class="text-neutral-n4" />
            <div class="form-row">
              <div class="form-group mb-15">
                <h4>UDH params</h4>
              </div>
              <app-udh-tlv-input #udhListComponent [tagSizeBytes]="1"></app-udh-tlv-input>
            </div>
            <div class="form-row">
              <div class="form-group mb-15">
                <h4>TLV params</h4>
              </div>
              <app-udh-tlv-input #tlvListComponent [tagSizeBytes]="2"></app-udh-tlv-input>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary box -->
      <div class="step-summary-box">
        <h3 class="summary-head">Summary:</h3>
        <div class="summary-body">
          <ng-container *ngIf="activeSessionForSupplier">
            <div class="summary-row">
              <div class="left-col">
                <span class="summary-title">Host</span>
              </div>
              <div class="right-col">
                <span class="d-block mb-0_8">
                  {{ activeSessionForSupplier.hostIp }}: {{ activeSessionForSupplier.hostPort }}
                  <span
                    class="fas fa-circle"
                    tooltip="This session is {{ activeSessionForSupplier.online ? 'online.' : 'offline.' }}"
                    [ngClass]="activeSessionForSupplier.online ? 'text-success-s2' : 'text-error-r2'"></span>
                </span>
              </div>
            </div>
            <div class="summary-row">
              <div class="left-col">
                <span class="summary-title">Login</span>
              </div>
              <div class="right-col">
                <span class="d-block mb-0_8">
                  {{ activeSessionForSupplier.systemId }}
                </span>
              </div>
            </div>
            <div class="summary-row">
              <div class="left-col">
                <span class="summary-title">Session ID</span>
              </div>
              <div class="right-col">
                <span class="d-block mb-0_8">
                  {{ activeSessionForSupplier.id }}
                </span>
              </div>
            </div>
            <hr class="horizontal-line text-neutral-n5" />
          </ng-container>

          <div class="summary-row">
            <span class="title-md">Supplier details</span>
            <div class="inner-row" *ngIf="model.title?.length">
              <div class="left-col">
                <span class="summary-title">Supplier Name: </span>
              </div>
              <div class="right-col">
                <div [title]="model.title" class="detail text-truncate">{{ model.title }}</div>
              </div>
            </div>
            <div class="inner-row" *ngIf="model.routeType?.length">
              <div class="left-col">
                <span class="summary-title">Route type: </span>
              </div>
              <div class="right-col">
                <div class="detail">{{ model.routeType }}</div>
              </div>
            </div>
            <div class="inner-row" *ngIf="attributeSelections">
              <div class="left-col">
                <span class="summary-title">Attributes:</span>
              </div>
              <div class="right-col">
                <div class="detail">
                  <ng-container *ngFor="let item of attributeSelections | keyvalue">
                    <div class="text-icon" *ngIf="item.value && attrToLabel[item.key]">
                      <span class="icon" [ngClass]="getIcon(item.key)"></span>
                      <span class="text">{{ attrToLabel[item.key] ? attrToLabel[item.key] : '' }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="inner-row" *ngIf="model.comment?.length">
              <div class="left-col">
                <span class="summary-title">Comment: </span>
              </div>
              <div class="right-col">
                <div class="detail">{{ model.comment }}</div>
              </div>
            </div>
          </div>
          <hr class="horizontal-line text-neutral-n4" />

          <div class="summary-row">
            <div class="title-md">Routing Parameters</div>
            <div class="inner-row" *ngIf="model.serviceType?.length">
              <div class="left-col">
                <span class="summary-title">Service type: </span>
              </div>
              <div class="right-col">
                <div class="detail">{{ model.serviceType }}</div>
              </div>
            </div>
            <div class="inner-row" *ngIf="udhListComponent?.getModels().length">
              <div class="left-col">
                <span class="summary-title"> UDH Parameters </span>
              </div>
              <div class="right-col">
                <div class="detail" *ngFor="let udhDetails of udhListComponent?.getModels()">
                  <span>Tag [HEX]: {{ udhDetails.tagHex }}</span
                  ><br />
                  <span>Value [HEX]: {{ udhDetails.valueHex }}</span>
                </div>
              </div>
            </div>

            <div class="inner-row" *ngIf="udhListComponent?.getModels().length">
              <div class="left-col">
                <span class="summary-title"> TLV Parameters </span>
              </div>
              <div class="right-col">
                <div class="detail" *ngFor="let tlvDetails of tlvListComponent?.getModels()">
                  <span>Tag [HEX]: {{ tlvDetails.tagHex }}</span
                  ><br />
                  <span>Value [HEX]: {{ tlvDetails.valueHex }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="step-buttons">
    <button type="button" class="btn btn-outline-primary px-20" (click)="afterSave.emit(null)">Cancel</button>
    <div class="button-group">
      <button type="button" class="text-button btn" (click)="prevStep()" *ngIf="currentStep === 2"><span class="icon-arrow-left"></span> Back</button>
      <button type="button" class="btn btn-primary px-20" (click)="nextStep()" *ngIf="currentStep === 1" [disabled]="!form.valid">
        Continue <span class="icon-arrow-right"></span>
      </button>
      <button type="submit" class="btn btn-primary px-20" *ngIf="currentStep === 2" [disabled]="!valid">Save</button>
    </div>
  </div>
</form>
